const LOCATIONS_KEYS = {
  // Location Groups
  LOCATION_GROUPS: () => ['location-groups'],
  LOCATION_GROUPS_DETAIL: (uid) => [...LOCATIONS_KEYS.LOCATION_GROUPS(), 'detail', uid],
  LOCATION_GROUPS_AVAILABLE_LOCATIONS: () => [
    ...LOCATIONS_KEYS.LOCATION_GROUPS(),
    'available-locations',
  ],

  // Locations
  LOCATIONS: () => ['locations'],
  LOCATIONS_LISTS: () => [...LOCATIONS_KEYS.LOCATIONS(), 'list'],
  LOCATIONS_LIST: (regionUid) => [...LOCATIONS_KEYS.LOCATIONS_LISTS(), regionUid],
  LOCATION: (uid) => [...LOCATIONS_KEYS.LOCATIONS(), 'detail', uid],
  LOCATION_AVAILABLE_USERS: (uid) => [...LOCATIONS_KEYS.LOCATION(uid), 'available-users'],
  LOCATION_AVAILABLE_LOOKS: (uid) => [...LOCATIONS_KEYS.LOCATION(uid), 'available-looks'],
  LOCATION_AVAILABLE_BANNERS: (uid) => [...LOCATIONS_KEYS.LOCATION(uid), 'available-banners'],
  LOCATION_AVAILABLE_VIDEOS: (uid) => [...LOCATIONS_KEYS.LOCATION(uid), 'available-videos'],
  LOCATION_AVAILABLE_PARTICIPANTS: (uid) => [
    ...LOCATIONS_KEYS.LOCATION(uid),
    'available-participants',
  ],
  LOCATION_AVAILABLE_EVENTS: (uid) => [...LOCATIONS_KEYS.LOCATION(uid), 'available-events'],
  LOCATION_AVAILABLE_MODULES: (uid) => [...LOCATIONS_KEYS.LOCATION(uid), 'available-modules'],
};

export default LOCATIONS_KEYS;
